import ReactDatePicker from "react-datepicker";
import format from "date-fns/format";
import { useState, useRef, forwardRef } from "react";
import styled from "styled-components";
import styles from "../../styles/General/Input.module.css"

const StyledInput = styled.input`
    &::placeholder {
        font-size : 13px;
        font-weight : 300
    }
    &:disabled {
        opacity : 0.6;
    }
    &::before {
        content: attr(placeholder);
        position: absolute;
        color: #999999;
    }

    &:focus::before,
    &:valid::before {
        content: "";
    }

    color-scheme: dark;
`

function DatePicker(props: any) {
    const inputRef : any = useRef(null);

    // FUNCTIONS

    const ExampleCustomInput : any = forwardRef(({ value, onClick }: any, ref) => (
        <div className="flex-col">
            {
                props.label && 
                <label className={`inline-block mb-1 ${props.labelProperties}`} style={{ color : props.labelColor }}> {props.label} </label>
            }
            <div onClick={() => inputRef.current.focus()} className={`flex bg-white justify-center items-center cursor-text ${props.outerProperties}`} style={{ background : props.background }}>
                {
                    props.prefix && 
                    <div className={styles.prefix}>
                        {props.prefix}
                    </div>
                }

                <StyledInput
                    ref = {inputRef}
                    className={`${styles.input} focus:outline-0 ${props.properties}`}
                    type="text"
                    placeholder={props.placeholder}
                    style={{ background : props.background, color : props.color }}
                    name = {props.name}
                    defaultValue={value}
                    onFocus={onClick}
                    disabled = {props.disabled}
                    onBlur = {props.onBlur}
                />

                <div className="suffix">
                    {props.suffix}
                </div>
            </div>
            {   
                props.error && props.touched &&
                <small className="text-error"> { props.error } </small>
            }
        </div>
    ));
        
    return (
        <div> 
            <ReactDatePicker
                isClearable
                selected={props.initialValue}
                onChange={props.onChange}
                showMonthDropdown
                showYearDropdown
                customInput = {<ExampleCustomInput />}
                dateFormat={'yyyy-MM-dd'}
                minDate={props.minimumDate}
            />
        </div>
    )
}

DatePicker.defaultProps = {
    placeholder : '',
    prefix : '',
    suffix : '',
    outerProperties : '',
    autoComplete : false,
    background : 'white',
    color : 'black',
    labelColor : 'white',
    labelProperties : '',
    touched : false,
    error : null,
    disabled : false,
    minimumDate : null
}

export default DatePicker